import React from 'react'
import { Tabs } from 'antd'

import { AddAdmin } from 'App/components/AdminManagement/AddAdmin'
import { AdminList } from 'App/components/AdminManagement/AdminList'

import styles from './AdminManagement.module.scss'

const { TabPane } = Tabs

export const AdminManagement = () => (
  <div className={styles.root}>
    <Tabs defaultActiveKey="1">
      <TabPane tab="Add admin" key="1">
        <AddAdmin />
      </TabPane>
      <TabPane tab="Admin list" key="2">
        <AdminList />
      </TabPane>
    </Tabs>
  </div>
)
